import { IconButton } from "@chakra-ui/react"
import React from "react"
import { BsPrinter } from "react-icons/bs"

export const PrintIconButton: React.FC<{
	onClick?: Function | (() => void)
	size?: string
}> = ({ onClick, size, ...rest }) => (
	<IconButton
		aria-label="edit"
		variant="ghost"
		icon={<BsPrinter />}
		size={size ?? "sm"}
		mx="1"
		colorScheme={"blue"}
		onClick={() => onClick && onClick()}
		{...rest}
	/>
)
